import i18n from '@/plugins/i18n';
import { ref } from 'vue';
export function useDocumentTitle() {
    const isLoaded = ref(false);
    function setTitle(title: string, pageName?: string): void {
        const namePage = localStorage.getItem('namePage') || '';
        if (!isLoaded.value) {
            document.title = title;
            setTimeout(() => {
                documentTitle(title, pageName, namePage);
                isLoaded.value = true;
            }, 500);
        } else {
            documentTitle(title, pageName, namePage);
        }
    }
    function documentTitle(title: string, pageName?: string, namePage?: string): void {
        document.title = `${i18n.global.t(namePage || pageName || 'home')} | ${title}`;
    }
    return {
        setTitle,
        documentTitle
    };
}
